/* SAP — Concern-page sticky CTA (concern-pages-2026)
   A persistent bottom bar that slides up once the reader has scrolled PAST the
   Protocol section, carrying the full-system offer + a link to the PDP. Unlike
   the PDP's sap-sticky-atc, this is a link — concern pages have no buy box to
   add from — so it works without the (localhost-inert) subscription cadence box.

   Trigger: IntersectionObserver on the section named by data-trigger (default
   "protocol"). The bar shows only while that section has scrolled fully above
   the top of the viewport; it hides when the reader is at/above it again. */
(function () {
  'use strict';

  function initBar(bar) {
    if (!bar) return;

    var triggerId = bar.getAttribute('data-trigger') || 'protocol';
    var trigger = document.getElementById(triggerId);

    /* Keep the hidden (translateY 100%) bar out of the tab order / AT tree
       (WCAG 4.1.2), mirroring sap-sticky-atc. */
    bar.inert = bar.getAttribute('aria-hidden') !== 'false';

    /* No trigger on the page — leave the bar permanently hidden + inert. */
    if (!trigger) return;

    function show() {
      if (bar.classList.contains('is-visible')) return;
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
      bar.inert = false;
      /* Signal for the chat widget to rise above the bar (shared class). */
      document.body.classList.add('sap-sticky-visible');
    }

    function hide() {
      if (!bar.classList.contains('is-visible')) return;
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      bar.inert = true;
      document.body.classList.remove('sap-sticky-visible');
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          /* Visible only once the Protocol section has scrolled fully above the
             viewport top (not intersecting AND its top edge is negative). While
             the reader is inside or above Protocol, the bar stays hidden. */
          var scrolledPast =
            !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (scrolledPast) {
            show();
          } else {
            hide();
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(trigger);
  }

  /* Real add-to-cart, mirroring sap-pdp-cadence-box.js doAdd():
     POST /cart/add.js with the Full-System variant (+ subscription selling_plan
     for the $99 first-order intro) via the Section Rendering API, then hand the
     rendered cart-drawer section to Aurora's own drawer.purchaseHandler so every
     cart sub-block re-renders and the drawer opens — the native refresh path. On
     any failure, degrade to navigating to the PDP so the shopper is never stuck. */
  function initAtc(bar) {
    var btn = bar.querySelector('[data-sap-concern-atc]');
    if (!btn || btn.dataset.sapAtcBound) return;
    btn.dataset.sapAtcBound = '1';

    var label = btn.querySelector('[data-sap-atc-label]');
    var pdpUrl = btn.getAttribute('data-pdp-url');
    var adding = false;

    function fallback() {
      if (pdpUrl) window.location.href = pdpUrl;
    }

    btn.addEventListener('click', function () {
      if (adding) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) {
        fallback();
        return;
      }
      adding = true;
      btn.disabled = true;
      var prevLabel = label ? label.textContent : '';
      if (label) label.textContent = 'Adding…';

      var drawer = document.querySelector('cart-drawer');
      var sectionId = (drawer && drawer.dataset.sectionId) || 'cart-drawer';

      var body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      var plan = btn.getAttribute('data-selling-plan');
      if (plan) body.append('selling_plan', plan);
      body.append('sections', sectionId);
      body.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: body,
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var json = null;
            try {
              json = JSON.parse(text);
            } catch (_) {}
            if (!res.ok) {
              throw new Error(
                (json && (json.description || json.message)) || 'HTTP ' + res.status
              );
            }
            return json;
          });
        })
        .then(function (json) {
          var sectionHTML = json && json.sections && json.sections[sectionId];
          if (drawer && typeof drawer.purchaseHandler === 'function' && sectionHTML) {
            var parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
            drawer.purchaseHandler(parsed, json);
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            return;
          }
          /* purchaseHandler/section unavailable: refresh the count badge and open
             the drawer via its trigger — the item is already in the server cart. */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var trigger = document.querySelector(
            '[data-sidebar-button][data-sidebar-id="CartDrawer"]'
          );
          if (trigger) {
            trigger.click();
          } else {
            fallback();
          }
        })
        .catch(function () {
          fallback();
        })
        .finally(function () {
          adding = false;
          btn.disabled = false;
          if (label) label.textContent = prevLabel;
        });
    });
  }

  function boot() {
    var bars = document.querySelectorAll('[data-sap-concern-sticky]');
    for (var i = 0; i < bars.length; i++) {
      initBar(bars[i]);
      initAtc(bars[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
